<template>
  <div class="relative-pull d2-mt-20">
    <el-row v-loading="loadings" element-loading-text="提交中...">
      <el-form ref="form" :model="form" :label-width="formLabelWidth" v-loading="loading" element-loading-text="加载中..."
        :disabled='formReadOnly' class="formbirth d2-mr-20" size="small">
        <el-col :span="24">
          <div class="header_box d2-mb-20">
            <span></span>会员信息
          </div>
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item label="AD账号" prop="AdAccount"
                :rules="[{ required: true, message: 'AD账号不能为空', trigger: 'blur' }]">
                <el-input v-model="form.AdAccount" autocomplete="off" placeholder="请输入AD账号" readonly></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="中文姓名" prop="Name"
                :rules="[{ required: true, message: '中文姓名不能为空', trigger: 'blur' }]">
                <el-input v-model="form.Name" autocomplete="off" placeholder="请输入中文姓名" readonly></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="英文姓名" prop="Ename"
                :rules="[{ required: true, message: '英文姓名不能为空', trigger: 'blur' }]">
                <el-input v-model="form.Ename" autocomplete="off" placeholder="请输入英文姓名" readonly></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="工作部门" prop="Depart">
                <el-input v-model="form.Depart" autocomplete="off" placeholder="请输入工作部门" readonly></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="证件类型" prop="CardType"
                :rules="[{required: true, message: '证件类型不能为空', trigger: 'blur'}]">
                <el-select v-model="form.CardType" placeholder="请选择证件类型" class="w100" @change="changeCardType">
                  <el-option v-for="val in cardOption" :label="val.label" :value="val.value" :key="val.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="证件号" prop="IdCard"
                :rules="[{required: true,validator: rulesUtils.idNumber,trigger: ['change', 'blur']}]">
                <el-input placeholder="请输入证件号" :value="!idCardVisible && !scancard?judgeCard(form.IdCard):form.IdCard"
                  @input="form.IdCard = $event"
                  @focus="!first?showTipsDialog(form.IdCard):!scancard?idCardVisible=true:''"
                  @blur="!scancard?idCardVisible=false:''"><i slot="suffix"
                    :class="!idCardVisible?'el-icon-view':'el-icon-error'" :title="!idCardVisible?'查看完整证件号':'脱敏证件号'"
                    @click="IdCardHandle(idCardVisible)"></i></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item
                v-if="!(!form.IsForever || form.IsForever == '' ? false : form.IsForever == 'on' ? true : false)"
                label="证件有效期" prop="PaidUsedEndDate" :rules="[{required: true,message: '证件有效期不能为空', trigger: 'blur'}]">
                <el-date-picker v-model="form.PaidUsedEndDate" type="date" placeholder="请输入证件有效期" class="w100"
                  format="yyyy-MM-dd" value-format="yyyy-MM-dd">
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="是否长期" prop="IsForever">
                <el-checkbox label="长期"
                  :value="!form.IsForever || form.IsForever == '' ? false : form.IsForever == 'on' ? true : false"
                  @change="val => $set(form,'IsForever',val ? 'on' : 'off')" style="height: 33px;"></el-checkbox>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item label="证件正面" prop="IdCardImg1"
                :rules="form.CardType=='身份证'?[{ required: false, message: '证件正面不能为空', trigger: ['blur', 'change']}]:[]">
                <el-upload ref="upload" name='IdCardImg1' class="avatar-uploader"
                  :on-remove="handleRemove(form.IdCardImg1)" :on-exceed="handleExceed" action="#" :limit="10"
                  :http-request="uploadFile" :show-file-list="false" :before-upload="beforeAvatarUpload">
                  <template v-if="form.IdCardImg1">
                    <el-image v-if="form.IdCardImg1 != null"
                      :src="form.IdCardImg1.indexOf('http')!=-1?form.IdCardImg1:$apiUrl + form.IdCardImg1"
                      class="avatar"
                      :preview-src-list="[form.IdCardImg1.indexOf('http')!=-1?form.IdCardImg1:$apiUrl + form.IdCardImg1]">
                    </el-image>
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                  </template>
                  <template v-else>
                    <i class="el-icon-plus avatar-uploader-icon"></i>
                  </template>
                </el-upload>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="证件反面" prop="IdCardImg2"
                :rules="form.CardType=='身份证'?[{ required: false, message: '证件反面不能为空', trigger: ['blur', 'change']}]:[]">
                <el-upload ref="upload" name='IdCardImg2' class="avatar-uploader"
                  :on-remove="handleRemove(form.IdCardImg2)" :on-exceed="handleExceed" action="#" :limit="10"
                  :http-request="uploadFile" :show-file-list="false" :before-upload="beforeAvatarUpload">
                  <template v-if="form.IdCardImg2">
                    <el-image v-if="form.IdCardImg2 != null"
                      :src="form.IdCardImg2.indexOf('http')!=-1?form.IdCardImg2:$apiUrl + form.IdCardImg2"
                      class="avatar"
                      :preview-src-list="[form.IdCardImg2.indexOf('http')!=-1?form.IdCardImg2:$apiUrl + form.IdCardImg2]">
                    </el-image>
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                  </template>
                  <template v-else>
                    <i class="el-icon-plus avatar-uploader-icon"></i>
                  </template>
                </el-upload>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="上传头像" prop="avatarUrl"
                :rules="[{ required: true, message: '头像不能为空', trigger: ['blur', 'change']}]">
                <el-upload ref="upload" name='avatarUrl' class="avatar-uploader"
                  :on-remove="handleRemove(form.avatarUrl)" :on-exceed="handleExceed" action="#" :limit="10"
                  :http-request="uploadFile" :show-file-list="false" :before-upload="beforeAvatarUpload">
                  <template v-if="form.avatarUrl">
                    <el-image v-if="form.avatarUrl != null"
                      :src="form.avatarUrl.indexOf('http')!=-1?form.avatarUrl:$apiUrl + form.avatarUrl" class="avatar"
                      :preview-src-list="[form.avatarUrl.indexOf('http')!=-1?form.avatarUrl:$apiUrl + form.avatarUrl]">
                    </el-image>
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                  </template>
                  <template v-else>
                    <i class="el-icon-plus avatar-uploader-icon"></i>
                  </template>
                </el-upload>
                <span style="color:red;font-size:12px;">请上传本人头像</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item label="出生日期" prop="Birthday"
                :rules="[{required: true,message: '出生日期不能为空', trigger: 'blur'}]">
                <el-date-picker v-model="form.Birthday" type="date" placeholder="请输入出生日期" class="w100"
                  format="yyyy-MM-dd" value-format="yyyy-MM-dd" :picker-options="pickerOptions">
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="入职日期" prop="JoinDay">
                <el-date-picker v-model="form.JoinDay" type="date" placeholder="请输入入职日期" class="w100" readonly
                  format="yyyy-MM-dd" value-format="yyyy-MM-dd">
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="入会日期" prop="JoinMemberDay">
                <el-date-picker v-model="form.JoinMemberDay" type="date" placeholder="请输入会日期" class="w100" readonly
                  format="yyyy-MM-dd" value-format="yyyy-MM-dd">
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="Email" prop="Email">
                <el-input type="email" v-model="form.Email" autocomplete="off" placeholder="请输入Email"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="是否愿意办理会员服务卡" :rules="[{ required: true, message: '会员服务卡不能为空', trigger: 'blur' }]">
                <el-select v-model="form.CreateServiceCard" placeholder="请选择" class="w100">
                  <el-option v-for="val in CreateServiceCardOption" :label="val.label" :value="val.value" :key="val.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="办事处" prop="WorkUnit">
                <el-input v-model="form.WorkUnit" autocomplete="off" placeholder="请输入办事处" readonly></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="所属分站" prop="Substation">
                <el-input v-model="form.Substation" autocomplete="off" placeholder="请输入所属分站" readonly></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="所属小组" prop="GroupName" :rules="[{ required: true, message: '所属小组不能为空', trigger: 'blur' }]">
                <!-- <el-input v-model="form.GroupName" autocomplete="off" placeholder="请输入所属小组"></el-input> -->
                <el-select v-model="form.GroupName" placeholder="请选择" class="w100">
                  <el-option v-for="val in BelongGroupOption" :label="val.GroupName" :value="val.GroupName" :key="val.GroupName">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="小组长信息">
                <el-tag effect="dark" @click="open(form.AdAccount)">查看信息</el-tag>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="城市" prop="City" :rules="[{required: true,message: '城市不能为空', trigger: 'blur'}]">
                <el-cascader v-model="form.City" :options="options" :props="props" class="w100" @change="handleChange"
                  :key="cascaderId" :ref="cascaderId">
                </el-cascader>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="手机号码" prop="Mobile"
                :rules="[{required: true,validator: rulesUtils.validatePhone,trigger: 'blur'}]">
                <el-input placeholder="请输入手机号码" :value="!phoneVisible && !scan?judgePhone(form.Mobile):form.Mobile"
                  @input="form.Mobile = $event" @focus="!scan?phoneVisible=true:''" @blur="!scan?phoneVisible=false:''">
                  <i slot="suffix" :class="!phoneVisible?'el-icon-view':'el-icon-error'"
                    :title="!phoneVisible?'查看完整手机号码':'脱敏手机号码'" @click="IsPhoneHandle(phoneVisible)"></i></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="性别" prop="Sex" :rules="[{ required: true, message: '性别不能为空', trigger: 'blur' }]">
                <el-select v-model="form.Sex" placeholder="请选择性别" class="w100">
                  <el-option v-for="val in sexOption" :label="val.label" :value="val.value" :key="val.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="民族">
                <el-select clearable v-model="form.Ethnic" placeholder="请选择民族" class="w100">
                  <el-option v-for="item in EthnicOption" :key="item.label" :label="item.label" :value="item.label">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="学历">
                <el-select v-model="form.Education" placeholder="请选择学历" class="w100">
                  <el-option v-for="val in educationOption" :label="val.label" :value="val.value" :key="val.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="政治面貌">
                <el-select v-model="form.PoliticsStatus" placeholder="请选择政治面貌" class="w100">
                  <el-option v-for="val in PoliticsOption" :label="val.label" :value="val.value" :key="val.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="邮编" prop="PostCode">
                <el-input placeholder="请输入邮编" v-model.trim="form.PostCode"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="家庭住址" prop="HomeAddr">
                <el-input placeholder="请输入家庭住址" v-model.trim="form.HomeAddr"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-col>

        <!-- 父母及配偶父母 -->

        <el-col :span="24">
          <div class="header_box d2-mb-10">
            <span></span>父母及配偶父母
          </div>
          <p class="my_info_dec">信息内容用于活动、福利、票务、保险使用</p>
          <div v-if="form.parentList && form.parentList.length!=0">
            <el-row v-for="(item, index) in form.parentList" :key="index">
              <el-col :span='6'>
                <el-form-item label="姓名" :prop="`parentList[${index}].Name`"
                  :rules="[{required: true, validator: rulesUtils.validateName, trigger: 'blur'}]">
                  <el-input placeholder="" v-model="item.Name"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span='6'>
                <el-form-item label="证件类型" :prop="`parentList[${index}].CardType`">
                  <el-select v-model="item.CardType" placeholder="请选择证件类型" class="w100"
                    @change="selectcarttype(parentCardNumber[index],item.CardType,index,'parentList')">
                    <el-option v-for="val in cardOption" :label="val.label" :value="val.value" :key="val.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span='6'>
                <el-form-item label="证件号" :prop="`parentList[${index}].CardNumber`" :rules="parentCardNumber[index]">
                  <el-input :value="!item.CardNumberShow?judgeCard(item.CardNumber):item.CardNumber" autocomplete="off"
                    placeholder="请输入证件号"
                    @focus="showChildTipsDialog('parentList',index,item.isFirst,item.CardNumberShow,item.CardNumber)"
                    @input="item.CardNumber = $event" @change='changeNumber(item.CardNumber,index,"parentList")'><i
                      slot="suffix" :class="!item.CardNumberShow?'el-icon-view':'el-icon-error'"
                      :title="!item.CardNumberShow?'查看完整证件号':'脱敏证件号'"
                      @click="IsChildDesenHandle('parentList','CardNumberShow+'+index)"></i>
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span='6'>
                <el-form-item label="性别">
                  <el-select v-model="item.Sex" placeholder="请选择性别" class="w100">
                    <el-option v-for="val in sexOption" :label="val.label" :value="val.value" :key="val.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span='6'>
                <el-form-item label="关系" :prop="`parentList[${index}].RelationType`"
                  :rules="[{ required: true, message: '关系不能为空', trigger: 'blur' }]">
                  <el-select v-model="item.RelationType" placeholder="请选择关系" class="w100"
                    @change="selectRelationType(item.RelationType,index)">
                    <el-option v-for="val in RelationOption" :label="val.label" :value="val.value" :key="val.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span='6'>
                <el-form-item label="出生日期">
                  <el-date-picker v-model="item.Birthday" type="date" placeholder="请输入出生日期" class="w100"
                    format="yyyy-MM-dd" value-format="yyyy-MM-dd" :picker-options="pickerOptions">
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span='12'>
                <el-button class="add_btn" icon="el-icon-delete" style="margin-left:100px;" type="danger" round
                  size="small" @click="deleteParent(item, index)">删除
                </el-button>
              </el-col>
              <el-col :span='24'>
                <el-form-item label="关系证明">
                  <el-upload ref="upload" :name='`parentList+${index}+BirthIdentity`'
                    :data='{BirthIdentity:item.BirthIdentity}' class="avatar-uploader" action="#"
                    accept=".jpeg,.png,.jpg" :before-upload="beforeAvatarUpload" :http-request="uploadFile"
                    :on-remove="(val)=>handleRemove1(val,item.BirthIdentity,`parentList+${index}+BirthIdentity`)"
                    :limit="10" list-type="picture-card" :file-list="item.fileList" :on-exceed="handleExceed1"
                    :on-preview="handlePictureCardPreview">
                    <i class="el-icon-plus avatar-uploader-icon"></i>
                  </el-upload>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
          <div v-else class="auto">
            <el-empty :image-size="100"></el-empty>
          </div>
          <div class="auto d2-text-center">
            <el-button class="add_btn" type="primary" round size="small" @click="addParent">添加</el-button>
          </div>
        </el-col>

        <!-- 配偶信息 -->

        <el-col :span="24">
          <div class="header_box d2-mb-10">
            <span></span>配偶信息
          </div>
          <p class="my_info_dec">信息内容用于活动、福利、票务、保险使用</p>
          <div v-if="form.spouseList && form.spouseList.length!=0">
            <el-row v-for="(item, index) in form.spouseList.slice(0,1)" :key="index">
              <el-col :span='6'>
                <el-form-item label="姓名" :prop="`spouseList[${index}].Name`"
                  :rules="[{required: true, validator: rulesUtils.validateName, trigger: ['change','blur']}]">
                  <el-input placeholder="" v-model="item.Name"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span='6'>
                <el-form-item label="证件类型" :prop="`spouseList[${index}].CardType`">
                  <el-select v-model="item.CardType" placeholder="请选择证件类型" class="w100"
                    @change="selectcarttype(spouseCardNumber[index],item.CardType,index,'spouseList')">
                    <el-option v-for="val in cardOption" :label="val.label" :value="val.value" :key="val.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span='6'>
                <el-form-item label="证件号" :prop="`spouseList[${index}].CardNumber`" :rules="spouseCardNumber[index]">
                  <!-- <el-input :value="!idCardVisible+index?judgeCard(item.CardNumber):item.CardNumber" autocomplete="off"
                    placeholder="请输入证件号" @focus="showTipsDialog(item.CardNumber)" @input="item.CardNumber = $event"
                    @change='changeNumber(item.CardNumber,index,"spouseList")'><i slot="suffix"
                      :class="!idCardVisible+index?'el-icon-view':'el-icon-error'"
                      :title="!idCardVisible+index?'查看完整证件号':'脱敏证件号'" @click="IdCardHandle(idCardVisible+index)"></i>
                  </el-input> -->

                  <el-input :value="!item.CardNumberShow?judgeCard(item.CardNumber):item.CardNumber" autocomplete="off"
                    placeholder="请输入证件号"
                    @focus="showChildTipsDialog('spouseList',index,item.isFirst,item.CardNumberShow,item.CardNumber)"
                    @input="item.CardNumber = $event" @change='changeNumber(item.CardNumber,index,"spouseList")'><i
                      slot="suffix" :class="!item.CardNumberShow?'el-icon-view':'el-icon-error'"
                      :title="!item.CardNumberShow?'查看完整证件号':'脱敏证件号'"
                      @click="IsChildDesenHandle('spouseList','CardNumberShow+'+index)"></i>
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span='6'>
                <el-form-item label="性别">
                  <el-select v-model="item.Sex" placeholder="请选择性别" class="w100" disabled>
                    <el-option v-for="val in sexOption" :label="val.label" :value="val.value" :key="val.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span='6' v-show="false">
                <el-form-item label="关系" :prop="`spouseList[${index}].RelationType`"
                  :rules="[{ required: true, message: '关系不能为空', trigger: 'blur' }]">
                  <el-select v-model="item.RelationType" placeholder="请选择关系" class="w100"
                    @change="selectRelationType(item.RelationType,index)">
                    <el-option v-for="val in RelationOption" :label="val.label" :value="val.value" :key="val.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span='6'>
                <el-form-item label="出生日期">
                  <el-date-picker v-model="item.Birthday" type="date" placeholder="请输入出生日期" class="w100"
                    format="yyyy-MM-dd" value-format="yyyy-MM-dd" :picker-options="pickerOptions">
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span='24'>
                <el-form-item label="关系证明">
                  <el-upload ref="upload" :name='`spouseList+${index}+BirthIdentity`'
                    :data='{BirthIdentity:item.BirthIdentity}' class="avatar-uploader" action="#"
                    accept=".jpeg,.png,.jpg" :before-upload="beforeAvatarUpload" :http-request="uploadFile"
                    :on-remove="(val)=>handleRemove1(val,item.BirthIdentity,`spouseList+${index}+BirthIdentity`)"
                    :limit="10" list-type="picture-card" :file-list="item.fileList" :on-exceed="handleExceed1"
                    :on-preview="handlePictureCardPreview">
                    <i class="el-icon-plus avatar-uploader-icon"></i>
                  </el-upload>
                </el-form-item>
              </el-col>
              <el-col :span='24'>
                <div class="auto d2-text-center">
                  <el-button class="add_btn" icon="el-icon-delete" type="danger" round size="small"
                    @click="deleteSpouse(item, index)">删除
                  </el-button>
                </div>
              </el-col>
            </el-row>
          </div>
          <div v-else class="auto">
            <el-empty :image-size="100"></el-empty>
            <div class="auto d2-text-center">
              <el-button class="add_btn" type="primary" round size="small" @click="addSpouse">添加</el-button>
            </div>
          </div>
        </el-col>

        <!-- 子女信息 -->

        <el-col :span="24">
          <div class="header_box d2-mb-10">
            <span></span>子女信息
          </div>
          <p class="my_info_dec">信息内容用于六一儿童节福利、活动及相关补助</p>
          <div v-if="form.childrenList && form.childrenList.length!=0">
            <el-row v-for="(item, index) in form.childrenList" :key="index">
              <el-col :span='6'>
                <el-form-item label="姓名" :prop="`childrenList[${index}].Name`"
                  :rules="[{required: true, validator: rulesUtils.validateName, trigger: ['change','blur']}]">
                  <el-input placeholder="" v-model="item.Name"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span='6'>
                <el-form-item label="证件类型" :prop="`childrenList[${index}].CardType`"
                  :rules="[{required: true, message: '证件类型不能为空', trigger: 'blur'}]">
                  <el-select v-model="item.CardType" placeholder="请选择证件类型" class="w100"
                    @change="selectcarttype(childrenCardNumber[index],item.CardType,index,'childrenList')">
                    <el-option v-for="val in cardOption" :label="val.label" :value="val.value" :key="val.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span='6'>
                <el-form-item label="证件号" :prop="`childrenList[${index}].CardNumber`"
                  :rules="childrenCardNumber[index]">
                  <!-- <el-input :value="!idCardVisible+index?judgeCard(item.CardNumber):item.CardNumber" autocomplete="off"
                    placeholder="请输入证件号" @focus="showTipsDialog(item.CardNumber)" @input="item.CardNumber = $event"
                    @change='changeNumber(item.CardNumber,index,"childrenList")'><i slot="suffix"
                      :class="!idCardVisible+index?'el-icon-view':'el-icon-error'"
                      :title="!idCardVisible+index?'查看完整证件号':'脱敏证件号'" @click="IdCardHandle(idCardVisible+index)"></i>
                  </el-input> -->

                  <el-input :value="!item.CardNumberShow?judgeCard(item.CardNumber):item.CardNumber" autocomplete="off"
                    placeholder="请输入证件号"
                    @focus="showChildTipsDialog('childrenList',index,item.isFirst,item.CardNumberShow,item.CardNumber)"
                    @input="item.CardNumber = $event" @change='changeNumber(item.CardNumber,index,"childrenList")'><i
                      slot="suffix" :class="!item.CardNumberShow?'el-icon-view':'el-icon-error'"
                      :title="!item.CardNumberShow?'查看完整证件号':'脱敏证件号'"
                      @click="IsChildDesenHandle('childrenList','CardNumberShow+'+index)"></i>
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span='6'>
                <el-form-item label="性别" :prop="`childrenList[${index}].Sex`"
                  :rules="[{ required: true, message: '性别不能为空', trigger: 'blur' }]">
                  <el-select v-model="item.Sex" placeholder="请选择性别" class="w100">
                    <el-option v-for="val in sexOption" :label="val.label" :value="val.value" :key="val.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span='6' v-show="false">
                <el-form-item label="关系" :prop="`childrenList[${index}].RelationType`"
                  :rules="[{ required: true, message: '关系不能为空', trigger: 'blur' }]">
                  <el-select v-model="item.RelationType" placeholder="请选择关系" class="w100"
                    @change="selectRelationType(item.RelationType,index)">
                    <el-option v-for="val in RelationOption" :label="val.label" :value="val.value" :key="val.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span='6'>
                <el-form-item label="出生日期" :prop="`childrenList[${index}].Birthday`"
                  :rules="[{ required: true, message: '出生日期不能为空', trigger: 'blur' }]">
                  <el-date-picker v-model="item.Birthday" type="date" placeholder="请输入出生日期" class="w100"
                    format="yyyy-MM-dd" value-format="yyyy-MM-dd" :picker-options="pickerOptions">
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span='12'>
                <el-button class="add_btn" icon="el-icon-delete" style="margin-left:100px;" type="danger" round
                  size="small" @click="deleteChildren(item, index)">删除
                </el-button>
              </el-col>
              <el-col :span='24'>
                <el-form-item label="关系证明" :prop="`childrenList[${index}].BirthIdentity`"
                  :rules="[{ required: true, message: '关系证明不能为空', trigger: 'blur' }]">
                  <el-upload ref="upload" :name='`childrenList+${index}+BirthIdentity`'
                    :data='{BirthIdentity:item.BirthIdentity}' class="avatar-uploader" action="#"
                    accept=".jpeg,.png,.jpg" :before-upload="beforeAvatarUpload" :http-request="uploadFile"
                    :file-list="item.fileList"
                    :on-remove="(val)=>handleRemove1(val,item.BirthIdentity,`childrenList+${index}+BirthIdentity`)"
                    :limit="10" list-type="picture-card" :on-exceed="handleExceed1"
                    :on-preview="handlePictureCardPreview">
                    <i class="el-icon-plus avatar-uploader-icon"></i>
                  </el-upload>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
          <div v-else class="auto">
            <el-empty :image-size="100"></el-empty>
          </div>
          <div class="auto d2-text-center">
            <el-button class="add_btn" type="primary" round size="small" @click="addChildren">添加</el-button>
          </div>
          <br>
        </el-col>
      </el-form>
    </el-row>

    <div class="flow_Record d2-mt-5" v-if="flowRecord.length!=0">
      <el-steps direction="vertical" :active="active" active-color="#4196ff">
        <el-step v-for="(item, i) in flowRecord" :key="i" icon="el-icon-success">
          <div slot="description" class="step-box" @click="item.Receiver?look(item):''">
            <img
              :src="item.AvatarUrl && item.AvatarUrl != '' ? $apiUrl + item.AvatarUrl : require('@/assets/img/avatarUrl.png') " />
            <div class="step-infobox">
              <div class="user">
                {{ item.ProcessBy ? `${item.ProcessByName}(${item.ProcessBy})` : item.Actor}}
              </div>
              <div class="time">{{ item.ProcessTime }}</div>
              <div class="action">{{ item.Actor }}</div>
              <div class="time">
                {{item.Action == ""? item.Actor == "开始"? "待提交": "待审批" : item.Action}}
                {{ item.Receiver ? "(点击查看详情)" : "" }}
              </div>
              <div>{{ item.Content }}</div>
            </div>
          </div>
        </el-step>
      </el-steps>
    </div>
    <!-- 禁用 -->
    <!-- <template v-if="!formReadOnly">
      <div class="web_btn" v-if="formStatus==-1 && unitname.uInfo.MemberStatus==2 && checked.name=='入会申请'">
        <el-button class="add_btn" type="primary" round @click="submitHandle(form.RoleName)">提交入会申请</el-button>
      </div>
      <div class="web_btn" v-else>
        <el-button class="add_btn d2-mr-10" type="primary" round @click="addToRush('入会申请审批表','入会申请审批加催')">加催
        </el-button>
        <el-button class="add_btn d2-ml-10" type="primary" round @click="abolish('入会申请审批表')">撤销申请</el-button>
      </div>
    </template> -->
    <!-- 正式会员 查看信息 修改（提交修改） 加催 撤销申请  -->
    <template v-if="form.RoleName=='正式会员'">
      <div class="web_btn" v-if="formStatus==-1">
        <el-button class="add_btn" type="primary" round @click="submitHandle(form.RoleName)">提交修改</el-button>
      </div>
      <div class="web_btn" v-else>
        <el-button class="add_btn d2-mr-10" type="primary" round @click="addToRush('会员信息修改审批单','会员修改审批加催')">加催
        </el-button>
        <el-button class="add_btn d2-ml-10" type="primary" round @click="abolish('会员信息修改审批单')">撤销申请</el-button>
      </div>
    </template>
    <!-- 预备会员满 三个月 提交入会申请 加催 撤销申请  -->
    <!-- 实习生 、 预备会员满 未三个月 仅查看信息 -->
    <template v-if="form.RoleName=='预备会员' && !formReadOnly">
      <div class="web_btn" v-if="formStatus==-1">
        <el-button v-if="unitname.uInfo.MemberStatus==2 && checked.name=='入会申请'" class="add_btn" type="primary" round
          @click="submitHandle(form.RoleName)">提交入会申请</el-button>
      </div>
      <div class="web_btn" v-else>
        <el-button class="add_btn d2-mr-10" type="primary" round @click="addToRush('入会申请审批表','入会申请审批加催')">加催
        </el-button>
        <el-button class="add_btn d2-ml-10" type="primary" round @click="abolish('入会申请审批表')">撤销申请</el-button>
      </div>
    </template>

    <el-dialog title="提醒" :visible.sync="dialogVisible" width="50%" :before-close="handleClose" :append-to-body="true">
      <div class="web_view_con" v-html="htmlcon"></div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false" plain size="small">取 消</el-button>
        <el-button type="primary" @click="showIdCard" size="small">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 小组长信息 -->
    <el-dialog title="小组长信息" :visible.sync="dialogGroupVisible" width="45%" :before-close="handleGroupClose"
      :append-to-body="true">
      <el-table :data="groupList" style="width: 100%">
        <el-table-column prop="Name" label="姓名">
        </el-table-column>
        <el-table-column prop="Mobile" label="电话">
        </el-table-column>
        <el-table-column prop="Email" label="邮箱">
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogGroupVisible = false" plain size="small">取 消</el-button>
      </span>
    </el-dialog>

    <!-- 待审批 -->
    <el-dialog :visible.sync="dialogReceiverVisible" width="40%" :before-close="handleReceiverClose"
      :append-to-body="true">
      <div v-for="(item,index) in ReceiverList" :key="index">
        <div class="receiver_sec">
          <d2-icon class="receiver_sec_icon" name='users' />
          <div class="receiver_sec_info">
            <p>姓名：{{item.Name}}</p>
            <p>邮箱：{{item.Email}}</p>
          </div>
        </div>
        <div class="border_all"></div>
      </div>
    </el-dialog>

    <!-- 查看大图 -->
    <el-dialog :visible.sync="dialogImgVisible">
      <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog>
  </div>
</template>

<script>
  import * as indexService from "@/api/sys/index";
  import dayjs from "dayjs";
  import rules from "@/libs/rules";
  import richTextData from "@/libs/richTextData";
  import _ from "lodash";
  const form = {
    AdAccount: '',
    Name: '',
    Ename: '',
    Email: '',
    Depart: '',
    CardType: '',
    IdCard: '',
    PaidUsedEndDate: '',
    CreateServiceCard:''
  }
  export default {
    name: "myInfo",
    components: {},
    data() {
      return {
        loadings: false,
        rulesUtils: rules,
        form: {
          parentList: [],
          spouseList: [],
          childrenList: [],
        },
        // 验证规则
        parentCardNumber: [],
        spouseCardNumber: [],
        childrenCardNumber: [],
        EthnicOption: richTextData.MingZu,
        educationOption: richTextData.education,
        PoliticsOption: richTextData.Politics,
        CreateServiceCardOption: richTextData.CreateServiceCard,
        BelongGroupOption: [],
        sexOption: [{
            label: "男",
            value: "男",
          },
          {
            label: "女",
            value: "女",
          },
        ],
        cardOption: [{
            label: "身份证",
            value: "身份证",
          },
          {
            label: "护照",
            value: "护照",
          },
          {
            label: "其他",
            value: "其他",
          },
        ],
        RelationOption: [{
            label: '父亲',
            value: '父亲',
            only: true,
            sex: "男"
          },
          {
            label: '母亲',
            value: '母亲',
            only: true,
            sex: "女"
          },
          {
            label: '配偶父亲',
            value: '配偶父亲',
            only: true,
            sex: "男"
          },
          {
            label: '配偶母亲',
            value: '配偶母亲',
            only: true,
            sex: "女"
          },
        ],
        formLabelWidth: "100px",
        pickerOptions: {
          //日期选择
          disabledDate(date) {
            return date.getTime() > Date.now();
          },
        },
        first: false,
        dialogVisible: false,
        htmlcon: '',
        // 脱敏
        idCardVisible: false,
        phoneVisible: false,
        scancard: false,
        scan: false,
        // 
        props: {
          value: "id", // ID字段名
          label: 'text', // 显示名称
          children: 'children' // 子级字段名
        },
        cascaderId: 1,
        groupList: [],
        dialogGroupVisible: false, //小组长弹窗

        // 待审核
        dialogReceiverVisible: false,
        ReceiverList: [],

        dialogImgVisible: false, //查看大图
        dialogImageUrl: '',
        addRushPopupShow: false,
        workFlowStatus: null,
        active: 0,
      };
    },
    created() {
      // this.form = this.mainData
      this.setValue();
    },
    mounted() {
      this.GetGroupByUser();
    },
    computed: {
      unitname() {
        return this.$store.state.d2admin.userInfo.userinfo;
      },
    },
    props: {
      code: {
        type: String,
        required: false,
        default: "",
      },
      checked: {
        type: Object,
        required: false,
        default: {},
      },
      childrenData: {
        type: Array,
        required: false,
        default: () => [],
      },
      mainData: {
        type: Object,
        required: false,
        default: () => {},
      },
      options: {
        type: Array,
        required: false,
        default: () => [],
      },
      formReadOnly: {
        type: Boolean,
        required: false,
        default: false,
      },
      loading: {
        type: Boolean,
        required: false,
        default: false,
      },
      formStatus: {
        type: Number,
        required: false,
        default: -1,
      },
      flowRecord: {
        type: Array,
        required: false,
        default: () => [],
      },
    },
    watch: {
      mainData(val) {
        this.setValue(val)
      },
      "form.CardType": function (val) {
        this.rulesUtils.changeCardType(val);
        if (this.form.IDCard || val) {
          if (
            this.form.IDCard &&
            this.form.IDCard.length === 18 &&
            this.form.CardType == "身份证"
          ) {
            this.$refs.form.validateField("IDCard", (e) => {
              if (!e) {
                this.form.Birth =
                  this.form.IDCard.substring(6, 10) +
                  "-" +
                  this.form.IDCard.substring(10, 12) +
                  "-" +
                  this.form.IDCard.substring(12, 14);
                this.form.Sex =
                  parseInt(this.form.IDCard.substr(16, 1)) % 2 == 1 ?
                  "男" :
                  "女";
              }
            });
          }
        }
      },
      // 计算初始日期
      "form.IDCard": function (val) {
        if (this.form.CardType || val) {
          let v = val;
          if (v.length === 18 && this.form.CardType == "身份证") {
            this.$refs.form.validateField("IDCard", (e) => {
              if (!e) {
                this.form.Birth =
                  v.substring(6, 10) +
                  "-" +
                  v.substring(10, 12) +
                  "-" +
                  v.substring(12, 14);
                this.form.Sex =
                  parseInt(v.substr(16, 1)) % 2 == 1 ? "男" : "女";
              }
            });
          }
        }
      },
    },
    methods: {
      GetGroupByUser(){
        indexService.GetMemberApply().then((data) => {
          let parmas={};
          if(data.data.length==0 && Array.isArray(data.data)){
            parmas={
              ID:0
            }
          }else{
            parmas={
              ID:data.data.mainData.ID
            }
          }
          indexService.GetGroupByUser(parmas).then((data) => {
            this.BelongGroupOption=data.data;
          });
        });
      },
      setValue(val) {
        this.form = val ? val : this.mainData;
        this.active = this.flowRecord.length;
        this.childrenData.forEach(v => {
          if (v.shortTitle == '父母信息') {
            this.form.parentList = v.data
          } else if (v.shortTitle == '配偶信息') {
            this.form.spouseList = v.data
          } else if (v.shortTitle == '子女信息') {
            this.form.childrenList = v.data
          }

          v.data.forEach(n => {
            Object.keys(n).forEach(key => {
              if (key == 'BirthIdentity' && n[key] != '') {
                let imgList = n[key].split(',');
                let imgList1 = imgList.map(v => {
                  return this.$apiUrl + v
                })
                let fileList = imgList.map((v, index) => {
                  return {
                    name: index,
                    url: this.$apiUrl + v
                  }
                })
                this.$set(n, 'fileList', fileList)
                n[key] = n[key].split(',')
              }
            })
          })
        });
      },
      //脱敏
      judgeCard(val) {
        if (!val) return ''
        let reg = /^(.{3}).*(.{2})$/
        return val.replace(/(?<=\d{3})\d{13}(?=\d{2})/, "************")
      },
      // 手机号脱敏
      judgePhone(val) {
        if (!val) return ''
        return val.replace(/(?<=\d{3})\d{4}(?=\d{4})/, "*****")
      },
      //添加父母信息
      addParent() {
        this.form.parentList.push({
          RelationType: "",
          Name: "",
          Birthday: '',
          Sex: '',
          CardType: '',
          CardNumber: '',
          BirthIdentity: ''
        });
        this.$forceUpdate()
      },
      //删除
      deleteParent(item, index) {
        this.form.parentList.splice(index, 1);
        this.$forceUpdate()
      },
      //添加配偶信息
      addSpouse() {
        this.form.spouseList.push({
          RelationType: "配偶",
          Name: "",
          Birthday: '',
          Sex: this.form.Sex == '女' ? '男' : '女',
          CardType: '',
          CardNumber: '',
          BirthIdentity: ''
        });
        this.$forceUpdate()
      },
      //删除
      deleteSpouse(item, index) {
        this.form.spouseList.splice(index, 1);
        this.$forceUpdate()
      },
      //
      addChildren() {
        this.form.childrenList.push({
          RelationType: "子女",
          Name: "",
          Birthday: '',
          Sex: '',
          CardType: '',
          CardNumber: '',
          BirthIdentity: ''
        });
        this.childrenCardNumber.push({
          required: true,
          message: '证件号不能为空',
          trigger: "blur"
        })
        this.$forceUpdate()
      },
      //删除
      deleteChildren(item, index) {
        this.form.childrenList.splice(index, 1);
        this.$forceUpdate()
      },
      handleChange() {},
      open(code) {
        let query = {
          MemberCode: code
        }
        this.dialogGroupVisible = true
        indexService.GetGroupManager(query).then((data) => {
          this.groupList = data.data
        });
      },
      showTipsDialog(val) {
        if (!this.first && !this.idCardVisible && val != '') {
          this.dialogVisible = true;
          this.htmlcon = richTextData.confirmHtml;
          this.idCardVisible = true
        }
      },
      // 父母，子女，配偶
      showChildTipsDialog(item, index, isFirst, show, val) {
        if (!isFirst && !show && val != '') {
          this.dialogVisible = true;
          this.htmlcon = richTextData.confirmHtml
          this.form[item][index]['isFirst'] = true
        }
      },
      showIdCard() {
        this.dialogVisible = false;
        this.idCardVisible = true
        this.first = true;
      },
      // 手机脱敏切换
      IsPhoneHandle(flag) {
        this.phoneVisible = !this.phoneVisible;
        this.scan = !this.scan
      },
      // 证件脱敏切换
      IdCardHandle(flag) {
        this.idCardVisible = !this.idCardVisible;
        this.scancard = !this.scancard
      },
      IsChildDesenHandle(item, val) {
        let arr = val.split('+');
        this.form[item][arr[1]][arr[0]] = !this.form[item][arr[1]][arr[0]]
        this.$forceUpdate();
      },
      handleClose() {
        this.dialogVisible = false;
        this.htmlcon = ''
      },
      handleGroupClose() {
        this.dialogGroupVisible = false;
        this.groupList = []
      },
      handleReceiverClose() {
        this.dialogReceiverVisible = false;
        this.ReceiverList = []
      },
      look(item) {
        this.dialogReceiverVisible = true;
        this.ReceiverList = item.Receiver
      },
      // 加催
      addToRush(shortTitle, title) {
        var param = {
          shortTitle: shortTitle,
          dataId: this.form.ID,
          title: title
        };
        indexService.AddUrgentMessage(param).then((data) => {
          this.$message.success('加催成功，请耐心等待！')
          // this.getAddToRushStatus();
        }).catch((e) => {
          // this.$message.error(e)
        });
      },
      getAddToRushStatus(shortTitle) {
        var param = {
          shortTitle: shortTitle,
          dataId: this.form.ID
        };
        indexService.GetUrgentStatus(param).then((data) => {
          if (data.success) {
            this.$message.success('加催成功，请耐心等待！')
          } else {
            this.$message.error(data.message)
          }
          var {
            Status
          } = data.data;
          if (Status == 1) {
            // this.workFlowStatus = "加催中";
          }
        });
      },
      // 取消
      abolish() {
        this.$confirm('是否确定撤销申请?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.loadings = true;
          var param = {
            configId: this.form._CONFIG_ID
          };
          indexService.DischargePetition(param).then(() => {
            this.$message.success("撤销成功！");
            this.$emit('message')
            this.loadings = false;
          }).catch((e) => {
            this.$message.error(e);
            this.loadings = false;
          });
        }).catch(() => {

        });
      },
      // 提交
      submitHandle(RoleName) {
        this.$refs["form"].validate((valid, error, i) => {
          if (valid) {
            this.loadings = true;
            let mainData = _.cloneDeep(this.form);
            let childrenData = [];
            if (mainData.parentList.length != 0) {
              mainData.parentList.forEach(v => {
                if (v.BirthIdentity) v.BirthIdentity = v.BirthIdentity.toString()
                this.$delete(v, 'fileList')
                this.$delete(v, 'isFirst')
                this.$delete(v, 'CardNumberShow')
              })
              childrenData.push({
                shortTitle: '父母信息',
                data: mainData.parentList
              })

            }
            if (mainData.childrenList.length != 0) {
              mainData.childrenList.forEach(v => {
                if (v.BirthIdentity) v.BirthIdentity = v.BirthIdentity.toString()
                this.$delete(v, 'fileList')
                this.$delete(v, 'isFirst')
                this.$delete(v, 'CardNumberShow')
              })
              childrenData.push({
                shortTitle: '子女信息',
                data: mainData.childrenList
              })

            }
            if (mainData.spouseList.length != 0) {
              mainData.spouseList.map(v => {
                if (v.BirthIdentity) v.BirthIdentity = v.BirthIdentity.toString()
                this.$delete(v, 'fileList')
                this.$delete(v, 'isFirst')
                this.$delete(v, 'CardNumberShow')
              })
              childrenData.push({
                shortTitle: '配偶信息',
                data: mainData.spouseList
              })
            }
            this.$delete(mainData, 'childrenList')
            this.$delete(mainData, 'spouseList')
            this.$delete(mainData, 'parentList')
            let form = {
              childrenData: childrenData,
              dataId: 0,
              mainData: mainData,
            };
            if (RoleName == '正式会员') {
              form = {
                ...form,
                shortTitle: "会员信息表",
              }
              console.log(form)
              indexService.AddMemberChange({
                ...form
              }).then((data) => {
                this.$message.success("提交修改成功！");
                this.$emit('message', true)
                this.loadings = false;
              }).catch((e) => {
                this.loadings = false;
              });
            } else {
              form = {
                ...form,
                shortTitle: "入会申请审批表",
              }
              indexService.AddMemberApply({
                ...form
              }).then((data) => {
                this.$message.success("提交入会申请成功！");
                this.$emit('message')
                this.loadings = false;
              }).catch((e) => {
                this.loadings = false;
              });
            }
          } else {
            for (var key in error) {
              var item = error[key];
              for (var i = 0; i < item.length; i++) {
                if (item[i].message) {
                  this.$message.error(item[i].message);
                  return;
                } else {
                  if (i == item.length - 1) {
                    this.$message.error("校验不通过,请输入正确数据");
                    return;
                  }
                }
              }
            }
            return false;
          }
        });
      },
      //上传图片
      beforeAvatarUpload(file) {
        let isLt2M = file.size < 1024 * 5120;
        let isJPG = ["image/jpeg", "image/png", "image/jpg"].includes(file.type);

        if (!isJPG) {
          this.$message.error("上传图片只能是 JPG/PNG/JPEG 格式!");
        }
        if (!isLt2M) {
          this.$message.error("上传图片大小不能超过 2MB!");
        }
        return isJPG && isLt2M;
      },
      handleExceed() {
        this.$message.warning("只能上传一张图片!");
      },
      handleExceed1() {
        this.$message.warning("只能上传10张图片!");
      },
      handleRemove(value) {
        value = "";
      },
      handleRemove1(file, fileList, name) {
        let fullname = name.split('+')
        let list = fileList
        list.splice(file.name, 1)
        console.log(list)
        this.form[fullname[0]][fullname[1]][fullname[2]] = list.length == 0 ? '' : list;
        console.log(this.form[fullname[0]][fullname[1]][fullname[2]])
      },
      handlePictureCardPreview(file) {
        this.dialogImageUrl = file.url;
        this.dialogImgVisible = true;
      },
      //上传图片
      uploadFile(item) {
        // console.log(item)
        let _this = this;
        let file = item.file;
        let formdata = new FormData();
        formdata.append("image", item.file);
        indexService
          .uploadFile(formdata, item.file.name)
          .then((data) => {
            this.$message({
              type: "success",
              message: "图片上传成功!",
            });
            // item.onSuccess();
            if (item.data && item.filename) {
              let fullname = item.filename.split('+')
              let val = Object.keys(item.data)[0];
              Object.keys(this.form).map((key, index) => {
                if (key == fullname[0]) {
                  return this.form[key].map((v, i) => {
                    if (parseInt(fullname[1]) == i) {
                      console.log(v, val, data.data.filepath, item.data[val])
                      let arr = []
                      if (item.data[val]) arr = _.concat(arr, item.data[val])
                      arr.push(data.data.filepath)
                      v[val] = arr
                      // _this.$set(v,'fileList',v[val])
                      console.log(arr, v[val])
                      // v.fileList.push({
                      //   name: data.data.filename,
                      //   url: this.$apiUrl + data.data.filepath,
                      // });
                    }
                  })
                }
              });
            } else {
              _this.$set(this.form, item.filename, data.data.filepath)
            }
            console.log(this.form)
          })
          .catch((error) => {
            item.onError();
          });
      },
      //证件选择
      selectcarttype(rus, value, index, type) {
        if (value == "身份证") {
          rus = [{
            required: true,
            validator: rules.idCardValid,
            trigger: "blur"
          }];
        } else if (value == "Passport") {
          rus = [{
            required: true,
            validator: rules.isPassPortCard,
            trigger: "blur"
          }];
        } else {
          if (type == 'childrenList') {
            rus = [{
              required: true,
              message: '证件号不能为空',
              trigger: "blur"
            }]
          } else {
            rus = []
          }
        }
        let CardNumber = ''
        if (type == 'parentList') {
          CardNumber = this.form.parentList[index].CardNumber;
          this.parentCardNumber[index] = rus
        } else if (type == 'spouseList') {
          CardNumber = this.form.spouseList[index].CardNumber;
          this.spouseCardNumber[index] = rus
        } else if (type == 'childrenList') {
          CardNumber = this.form.childrenList[index].CardNumber;
          this.childrenCardNumber[index] = rus
        }
        this.$forceUpdate();
        if (CardNumber || value) {
          if (CardNumber.length === 18 && value == "身份证") {
            switch (type) {
              case 'parentList':
                this.$refs.form.validateField('parentList[' + index + '].CardNumber', e => {
                  if (!e) {
                    this.form.parentList[index].Sex = parseInt(CardNumber.substr(16, 1)) % 2 == 1 ? "男" : "女"
                    this.form.parentList[index].Birthday = CardNumber.substring(6, 10) + "-" + CardNumber.substring(
                      10, 12) + "-" + CardNumber.substring(12, 14);
                  }
                })
                break;
              case 'spouseList':
                this.$refs.form.validateField('spouseList[' + index + '].CardNumber', e => {
                  if (!e) {
                    this.form.spouseList[index].Birthday = CardNumber.substring(6, 10) + "-" + CardNumber.substring(
                      10, 12) + "-" + CardNumber.substring(12, 14);
                  }
                })
                break;
              case 'childrenList':
                this.$refs.form.validateField('childrenList[' + index + '].CardNumber', e => {
                  if (!e) {
                    this.form.childrenList[index].Sex = parseInt(CardNumber.substr(16, 1)) % 2 == 1 ? "男" : "女"
                    this.form.childrenList[index].Birthday = CardNumber.substring(6, 10) + "-" + CardNumber
                      .substring(
                        10, 12) + "-" + CardNumber.substring(12, 14);
                  }
                })
                break;
            }
          }
        }
      },
      //修改 证件号 同时修改性别及出生年月
      changeNumber(val, index, type) {
        let CardType = ''
        if (type == 'parentList') {
          CardType = this.form.parentList[index].CardType;
        } else if (type == 'spouseList') {
          CardType = this.form.spouseList[index].CardType;
        } else if (type == 'childrenList') {
          CardType = this.form.childrenList[index].CardType;
        }

        if (CardType || val) {
          let v = val
          if (v.length === 18 && CardType == "身份证") {
            switch (type) {
              case 'parentList':
                this.$refs.form.validateField('parentList[' + index + '].CardNumber', e => {
                  if (!e) {
                    this.form.parentList[index].Sex = parseInt(v.substr(16, 1)) % 2 == 1 ? "男" : "女"
                    this.form.parentList[index].Birthday = v.substring(6, 10) + "-" + v.substring(
                      10, 12) + "-" + v.substring(12, 14);
                  }
                })
                break;
              case 'spouseList':
                this.$refs.form.validateField('spouseList[' + index + '].CardNumber', e => {
                  if (!e) {
                    this.form.spouseList[index].Birthday = v.substring(6, 10) + "-" + v.substring(
                      10, 12) + "-" + v.substring(12, 14);
                  }
                })
                break;
              case 'childrenList':
                this.$refs.form.validateField('childrenList[' + index + '].CardNumber', e => {
                  if (!e) {
                    this.form.childrenList[index].Sex = parseInt(v.substr(16, 1)) % 2 == 1 ? "男" : "女"
                    this.form.childrenList[index].Birthday = v.substring(6, 10) + "-" + v.substring(10, 12) + "-" +
                      v.substring(12, 14);
                  }
                })
                break;
            }
          }
        }
      },
      //修改关系
      selectRelationType(val, index) {
        let that = this
        this.RelationOption.find(function (i) {
          if (i.value === val) {
            that.form.parentList[index].Sex = i.sex
          }
        });
      },
      changeCardType(val) {
        if (val != '身份证') {
          this.$refs['form'].clearValidate(['IdCardImg1'])
          this.$refs['form'].clearValidate(['IdCardImg2'])
        }
      },
    }
  };
</script>

<style lang="scss" scoped>
  @import "~@/assets/style/style.css";
  @import "~@/assets/style/richText.scss";

  .demo-drawer /deep/ .el-drawer__body {
    padding: 20px;
  }

  .letter_box {
    background: #ffffff;
    position: relative;
    width: auto;
    z-index: 5;
  }

  /deep/.el-main {
    padding: 0;
  }

  .no-data {
    height: 500px;
    line-height: 500px;
    text-align: center;
    color: #606266;
  }

  .user-pdf {
    position: relative;
  }

  .pdf-name {
    position: absolute;
    left: 75px;
    display: block;
    width: 300px;
    height: 60px;
    line-height: 60px;
    background-color: #323639;
    color: #ffffff;
    font-weight: bold;
  }

  .benefit_con {
    display: flex;
    padding: 20px;
  }

  .benefit_con .image {
    height: 180px;
    width: auto;
  }

  .benefit_con_info {
    flex: 1;
  }

  .formbirth /deep/ .el-form-item__content {
    line-height: auto;
  }

  .formbirth /deep/ .el-upload--picture-card {
    width: 100px;
    height: 100px;
    line-height: 100px;
  }

  .formbirth /deep/ .el-upload-list--picture-card .el-upload-list__item {
    width: 100px;
    height: 100px;
    transition: none !important;
  }

  .flow_Record {
    padding: 20px;
    margin: 0 20px;
    box-shadow: 0px 0px 15px #bfd3e8;
    border-radius: 10px;
    background: #fff;
  }

  /deep/ .el-step__description {
    padding-right: 0;
  }

  .step-box {
    display: flex;

    img {
      width: 40px;
      height: 40px;
      border-radius: 50%;
      margin-right: 4px;
    }
  }

  .step-infobox {
    display: flex;
    flex-direction: row;
    width: 100%;
    flex-wrap: wrap;
    align-items: baseline;
    background: #f7faff;
    padding: 8px;
    border-radius: 5px;

    div {
      width: 50%;
      margin-top: 6px;
    }

    .user {
      font-size: 14px;
      color: #000;
    }

    .action {
      color: #999;
      font-size: 14px;
    }

    .time {
      color: #999;
      text-align: right;
      font-size: 12px;
    }
  }
</style>